import OktaAuth, { type OktaAuth as OktaAuthType } from '@okta/okta-auth-js';

const issuer = import.meta.env.VITE_OKTA_ISSUER;
const clientId = import.meta.env.VITE_OKTA_CLIENT_ID;
const redirectUri = `${window.location.origin}/login/callback`;
const postLogoutRedirectUri = `${window.location.origin}/login`;

if (!(issuer && clientId)) {
  throw new Error('Missing Okta configuration: VITE_OKTA_ISSUER and VITE_OKTA_CLIENT_ID must be set');
}

const isProduction = import.meta.env.MODE === 'production';

export const oktaAuth = new OktaAuth({
  issuer,
  clientId,
  redirectUri,
  postLogoutRedirectUri,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  responseType: 'code',
  services: {
    autoRenew: true,
    autoRemove: true,
  },
  tokenManager: {
    secure: isProduction,
    storage: 'cookie',
  },
  cookies: {
    secure: isProduction,
    sameSite: 'lax',
  },
});

export const restoreOriginalUri = (_oktaAuth: OktaAuthType, originalUri: string) => {
  // Only allow same-origin paths to prevent open redirect attacks
  const safePath = originalUri?.startsWith('/') && !originalUri.startsWith('//') ? originalUri : '/';
  window.location.href = safePath;
};
